import Modal from '../Modal';

const ConfirmationDialog = (props) => {
 return <Modal open={props.open} setOpen={props.setOpen} type={"OK"} confirmFn={props.confirmFn} text={'Bedankt voor je deelname!'} title="Goed ontvangen"/>
}

export default ConfirmationDialog;
